import { render, staticRenderFns } from "./ProductionTaskType.vue?vue&type=template&id=af6c85ea&scoped=true&"
import script from "./ProductionTaskType.vue?vue&type=script&lang=js&"
export * from "./ProductionTaskType.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTaskType.vue?vue&type=style&index=0&id=af6c85ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6c85ea",
  null
  
)

export default component.exports